import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthLayoutComponent} from "./auth-layout/auth-layout.component";
import {FooterComponent} from "./footer/footer.component";
import {NavbarComponent} from "./navbar/navbar.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {NzMenuModule} from "ng-zorro-antd/menu";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzInputModule} from "ng-zorro-antd/input";
import {ForgotPasswordLayoutComponent} from './forgot-password-layout/forgot-password-layout.component';
import {DashboardLayoutComponent} from './dashboard-layout/dashboard-layout.component';
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzAvatarModule} from "ng-zorro-antd/avatar";
import {NzSpaceModule} from "ng-zorro-antd/space";
import {NzBreadCrumbModule} from "ng-zorro-antd/breadcrumb";


@NgModule({
    declarations: [
        AuthLayoutComponent,
        ForgotPasswordLayoutComponent,
    ],
    imports: [
        CommonModule,
        RouterOutlet,
        RouterLink,
        NzMenuModule,
        RouterLinkActive,
        NzIconModule,
        NzInputModule,
        NzButtonModule,
        NzAvatarModule,
        NzSpaceModule,
        NzBreadCrumbModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        DashboardLayoutComponent,
    ],
    exports: [
        ForgotPasswordLayoutComponent,
        AuthLayoutComponent,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        DashboardLayoutComponent,
    ]
})
export class LayoutsModule {
}
